import dayjs from 'dayjs';
import 'dayjs/locale/fr';

export const DISPLAY_DATE_FORMAT = 'DD MMM YYYY';
export const INPUT_DATE_FORMAT = 'DD MMM YYYY';
export const PICKER_DATE_FORMAT = 'dd MMM yyyy';
export const PICKER_DATE_PLACEHOLDER = 'DD MMM YYYY';

export const formatDisplayDate = (value, locale = 'en') => {
  if (!value) return '';

  const parsedValue = dayjs.utc(value);
  if (!parsedValue.isValid()) return '';

  return parsedValue.locale(locale).format(DISPLAY_DATE_FORMAT);
};

export const formatInputDate = (value) => {
  if (!value) return '';

  const parsedValue = dayjs.utc(value);
  if (!parsedValue.isValid()) return '';

  return parsedValue.format(INPUT_DATE_FORMAT);
};
